export default "__VITE_ASSET__BlDKST74__"